<template>
    <div>
      <div class="home">
        <div>
          <p class="home-span">个人信息收集清单</p>
        </div>
      </div>
      <div class="box">
          <span class="box-1">UKidSchool英语应用个人信息收集清单说明</span>
        <div>
          <p class="box-4">我们将向终端用户或开发者收集终端用户在使用相关的功能时产生的如下个人信息</p>
          <table class="dataintable">
              <tr>
                <th>个人信息类型</th>
                <th>处理目的及功能场景</th>
              </tr>
              <tr>
                <td>学员姓名</td>
                <td>用于完成平台注册及使用平台等功能</td>
              </tr>
              <tr>
                <td>手机号</td>
                <td>用于完成平台登录、注册及使用平台等功能</td>
              </tr>
              <tr>
                <td>性别</td>
                <td>用户自行设置</td>
              </tr>
              <tr>
                <td>手机型号</td>
                <td>排查崩溃问题,帮助APP提升稳定性，识别Crash等问题是否与手机型号有关；</td>
              </tr>
              <tr>
                <td>手机品牌</td>
                <td>排查崩溃问题,帮助APP提升稳定性，识别Crash等问题是否与手机品牌有关；</td>
              </tr>
              <tr>
                <td>Android系统版本</td>
                <td>排查崩溃问题,帮助APP提升稳定性，识别Crash等问题是否与Android系统版本有关</td>
              </tr>
              <tr>
                <td>厂商系统版本</td>
                <td>排查崩溃问题,帮助APP提升稳定性，识别Crash等问题是否与厂商系统版本有关；</td>
              </tr>
              <tr>
                <td>cpu架构类型</td>
                <td>排查崩溃问题,帮助APP提升稳定性，识别Crash等问题是否与cpu架构类型有关；</td>
              </tr>
              <tr>
                <td>设备是否root</td>
                <td>排查崩溃问题,帮助APP提升稳定性，识别Crash等问题是否与设备是否root有关；</td>
              </tr>
              <tr>
                <td>磁盘空间占用大小</td>
                <td>排查崩溃问题,帮助APP提升稳定性，识别Crash等问题是否与磁盘空间占用大小有关；</td>
              </tr>
              <tr>
                <td>sdcard空间占用大小</td>
                <td>排查崩溃问题,帮助APP提升稳定性，识别Crash等问题是否与sdcard空间占用大小有关；</td>
              </tr>
              <tr>
                <td>内存空间占用大小</td>
                <td>排查崩溃问题,帮助APP提升稳定性，识别Crash等问题是否与内存空间占用大小有关；</td>
              </tr>
              <tr>
                <td>网络类型</td>
                <td>排查崩溃问题,帮助APP提升稳定性，识别Crash等问题是否与网络类型有关；</td>
              </tr>
              <tr>
                <td>应用当前正在运行的进程名和PID</td>
                <td>在APP发生闪退时，判断当前进程的ANR状态，排查崩溃问题, 帮助APP提升稳定性；</td>
              </tr>
              <tr>
                <td>UUID</td>
                <td>通过算法计算出来的终端应用的唯一的标识，用于性能调优、故障分析兼容</td>
              </tr>
              <tr>
                <td>IP地址</td>
                <td>1，调用SDK的服务端相关接口2，用于性能调优、故障分析兼容</td>
              </tr>
              <tr>
                <td>WIFI状态</td>
                <td>用于判断WIFI的连通性</td>
              </tr>
              <tr>
                <td>运营商信息</td>
                <td>用于实现网络链路的选择与优化</td>
              </tr>
          </table>          
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import "../css/home.css";
  import rem from "../utils/rem";
  export default {
    name: "Home",
    components: {},
  };
  </script>
  